import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class TimeUtil {

    constructor(
    
    ) { }

    timeToDate( timeString: string ): Date
    {
        let date = new Date()

        if (!timeString) return undefined
        
        const timeArray = timeString.split(":")        

        if(timeArray.length <= 1 ) return undefined

        date.setHours   ( +timeArray[0] )
        date.setMinutes ( +timeArray[1] )
        if(timeArray.length > 1)
            date.setSeconds ( +timeArray[2] )

        return date
    }
    
    delay(ms: number) {
        return new Promise( resolve => setTimeout(resolve, ms) );
    }

    numberToTime( n: number ){
        try{
            const date = new Date(0);
            if      ( n == 0 )  return ""
            else if ( n < 0 )   date.setSeconds( -n ); 
            else                date.setSeconds(  n ); 
            return ( n >= 0 ? "" : "- " ) + date.toISOString().substr(11, 8);
        }catch(e){ return n }
    }
}
